module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy1"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("Copyright © 2016 Fordham University Press")])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, or any other—except for brief quotations in printed reviews, without the prior permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Fordham University Press has no responsibility for the persistence or accuracy of URLs for external or third-party Internet websites referred to in this publication and does not guarantee that any content on such websites is, or will remain, accurate or appropriate.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Fordham University Press also publishes its books in a variety of electronic formats. Some content that appears in print may not be available in electronic books.")])]), _c('p', {
    staticClass: "copy1"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("Visit us online at ")]), _c('a', {
    attrs: {
      "href": "http://www.fordhampress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.fordhampress.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Names: Bean, Christopher B.")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Title: Too great a burden to bear : the struggle and failure of the Freedmen’s Bureau in Texas / Christopher B. Bean.")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Description: First edition. | New York : Fordham University Press, 2016. | Series: Reconstructing America | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Identifiers: LCCN 2015042262 (print) | LCCN 2016006934 (ebook) | ISBN 9780823268757 (cloth : alkaline paper) | ISBN 9780823271764 (paper : alkaline paper) | ISBN 9780823268764 (ePub)")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Subjects: LCSH: African Americans—Texas—History—19th century. | Freedmen—Texas—History. | Reconstruction (U.S. history, 1865–1877)—Texas. | United States. Bureau of Refugees, Freedmen, and Abandoned Lands—Officials and employees—Biography. | United States. Bureau of Refugees, Freedmen, and Abandoned Lands—History. | Texas—Race relations—History—19th century. | BISAC: HISTORY / United States / Civil War Period (1850–1877). | SOCIAL SCIENCE / Ethnic Studies / African American Studies.")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Classification: LCC E185.93.T4 B43 2016 (print) | LCC E185.93.T4 (ebook) | DDC 305.896/073076409034—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("LC record available at "), _c('a', {
    attrs: {
      "href": "http://lccn.loc.gov/2015042262",
      "target": "_blank"
    }
  }, [_vm._v("http://lccn.loc.gov/2015042262")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("First edition")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 69
// module chunks = 0